module.exports = __webpack_public_path__ + "media/universities/emlyon-dc08f1f0.jpeg";